<template>
  <div id="item-google-review">
    <vx-card class="mt-3">
      <vs-row class="font-medium pb-3 flex justify-center md:justify-start">
        <div v-if="reviewData.avatar">
          <vs-avatar size="55px" :src="reviewData.avatar" @error="onErr(reviewData.avatar)"/>
        </div>
        <div v-else>
          <vs-avatar size="55px" :text="StringHelper.changeFormatAvatar(reviewData.user_name)" class="text-3xl"/>
        </div>
        <div class="flex flex-col md:ml-6 ml-0 justify-around">
          <div class="font-bold mt-3 mb-5 text-lg flex align-center mx-auto md:ml-0">
            <span class="color-black">{{reviewData.user_name}}</span>
            <img src="../../../assets/images/logo/google-plus.svg" width="30" height="30" class="ml-4" style="margin-top: 1px"/>
          </div>
          <div>
            <span class="vs-col w-1/2 mb-3">
              <feather-icon icon="PhoneIcon" svgClasses="w-4 h-4 stroke-current" class="w-1/6" />
              <span v-if="reviewData.customer">{{StringHelper.phoneNumberFormat(reviewData.customer.phone)}}</span>
              <span v-else>N/A</span>
            </span>
            <span class="vs-col w-1/2 mb-3">
              Last visit:
              <span v-if="reviewData.customer">{{changeFormat(reviewData.customer.last_visited)}}</span>
              <span v-else class="pr-6">N/A</span>
            </span>
            <span class="vs-col w-1/2">
              <feather-icon icon="MailIcon" svgClasses="w-4 h-4 stroke-current" class="w-1/6" />
              <span class="d-inline-block" style="max-width: 200px; overflow: hidden; text-overflow: ellipsis; display: inline-block; white-space: nowrap; transform: translateY(4px)" v-if="reviewData.customer">{{reviewData.customer.email}}</span>
              <span class="d-inline-block" style="max-width: 200px; overflow: hidden; text-overflow: ellipsis; display: inline-block; white-space: nowrap; transform: translateY(4px)" v-else>N/A</span>
            </span>
            <span class="vs-col w-1/2">
              Visit
              <span v-if="reviewData.customer">{{reviewData.customer.visit_count}}</span>
              <span v-else>N/A</span> times
            </span>
          </div>
        </div>
      </vs-row>
      <vs-divider></vs-divider>
      <div>
        <vs-row class="font-medium py-3 flex align-center">
          <img src="../../../assets/images/logo/google-plus.svg" width="40" height="40" class="ml-1"/>
          <span class="font-bold ml-4 text-lg color-black">Google Reviews</span>
        </vs-row>
        <vs-row class="flex align-center">
          <star-rating :rating="reviewData.rating" :read-only="true" :increment="1"></star-rating>
          <span class="ml-4 day font-light">{{changeFormat(reviewData.time_create)}}</span>
        </vs-row>
        <p class="pt-3" v-if='reviewData.content != null && reviewData.content != `""` '>{{JSON.stringify(reviewData.content)}}</p>
      </div>
      <div class="review-reply mt-6" v-if="reviewData.type == 'google_gmb'">
        <div class="review-ryply-content pl-3 py-0" v-if='reviewData.review_reply_comment != null && reviewData.review_reply_comment != `""`'>
          <p class="font-bold reply-title">Response from the owner</p>
          <p class="reply-content">
            {{JSON.stringify(reviewData.review_reply_comment)}}
            <feather-icon icon="Edit2Icon" svgClasses="w-4 stroke-current ml-3 cursor-pointer icon-group" style="transform: translateY(4px)" @click="editReply(reviewData)"/>
            <feather-icon icon="Trash2Icon" svgClasses="w-4 stroke-current ml-3 cursor-pointer icon-group" style="transform: translateY(4px)" @click="delRep(reviewData.review_id)"/>
          </p>
        </div>
        <div v-else>
          <vs-button color="success" class="p-1 px-3" @click="addReply(reviewData.review_id)">Reply</vs-button>
        </div>
      </div>

      <vs-popup class="reply-google-popup" title="Google reply" :active.sync="popupReply">
        <div class="pt-4">
            <vs-textarea v-model="reply_content" height="200"/>
            <div class="text-primary text-sm">
              <feather-icon icon="InfoIcon" svgClasses="h-4 w-4 stroke-current mr-2" style="transform: translateY(3px)"/>
              <span>When you reply a Google review here, your reply will be posted on Google too.</span>
            </div>
            <div class="w-full  flex justify-center mt-6">
              <btn-custom @click="saveReply">Reply</btn-custom>
            </div>
        </div>
      </vs-popup>

      <vs-popup class="holamundo delete-group delete-popup" title="Delete Reply" :active.sync="popupDeleteActive">
          <div class="text-center">
              <h3>Do you want to delete this reply?</h3>
              <div class="flex flex-wrap justify-center align-center p-6 mt-6">
              <vs-button class="mr-6 align-center delete-responsive" @click="deleteReply()">Delete</vs-button>
              <vs-button type="border" color="danger" class="cancel-responsive" @click.stop="popupDeleteActive = false">Cancel</vs-button>
              </div>
          </div>
      </vs-popup>
    </vx-card>
  </div>
</template>

<script>
import StarRating from "vue-star-rating";
import { StringHelper } from "../../../models/string_helper";
import moment from 'moment';
import {changeFormatHelper} from '../../../helper/datetimeHelper';
export default {
  name: "item-google-review",
  components: {
      StarRating,
      moment
  },
  props: {
    reviewData: {
      type: Object,
      required: true
    },
    infoObj: {
      type: Object
    }
  },
  data() {
    // console.log(this.reviewData)
    return {
      StringHelper,
      popupReply: false,
      reply_content: '',
      id_review: '',
      type: '',
      popupDeleteActive: false,
      action_type: ''
    };
  },
  watch: {
    popupReply: {
      immediate: true,
      handler() {
        if(this.popupReply) {
          document.body.classList.add('overflow-hidden');
        } else {
          document.body.classList.remove('overflow-hidden');
        }
      }
    }
  },
  methods: {
    openLoadingInDiv(){
      this.$vs.loading({
        container: '#app',
        scale: 0.8
      })
      if(this.loadTime){
        clearTimeout(this.loadTime);
        this.loadTime = null;
      }
      this.isOpenLoading = true;
      this.loadTime = setTimeout( ()=> {
        if(this.isOpenLoading) {
          this.closeLoading();
          this.$vs.dialog({
            color: 'danger',
            title: 'Notification',
            text: this.action_type + ' reply failed',
            acceptText: 'OK'
          })
        }
      }, 10000);
    },
    closeLoading() {
      this.$vs.loading.close('#app > .con-vs-loading');
      this.isOpenLoading = false;
    },
    delRep(id){
      this.popupDeleteActive = true;
      this.id_review = id;
    },
    addReply(id){
      this.id_review = id;
      this.popupReply = true;
      this.type = "add";
    },
    changeFormat(date){
      if(date) {
        return changeFormatHelper(date);
      } else {
        return 'N/A';
      }
    },
    onErr(src) {
      console.log('Cannot get avatar: ' + src);
    },
    saveReply() {
      const obj = {
        review_id :  this.id_review,
        comment: this.reply_content,
        infoObj: this.infoObj
      }
      if(this.type == "add"){
        this.action_type = 'Add';
        this.openLoadingInDiv();
        this.$store.dispatch("reviewList/REPLY_GOOGLE_REVIEW", obj).then(() => {
          this.closeLoading();
              this.$vs.notify({
                title:'Notification',
                text:'Add Reply Success',
                color:'success',
                position:'top-right'})
            }).catch(() => {
              this.closeLoading();
              this.$vs.notify({
                title:'Notification',
                text:'Add Reply Failed',
                color:'danger',
                position:'top-right'})
            });
        this.popupReply = false;
      }else{
        this.action_type = 'Update';
        this.openLoadingInDiv();
        this.$store.dispatch("reviewList/UPDATE_GOOGLE_REPLY_REVIEW", obj).then(() => {
           this.closeLoading();
              this.$vs.notify({
                title:'Notification',
                text:'Update Reply Success',
                color:'success',
                position:'top-right'})
            }).catch(() => {
              this.closeLoading();
              this.$vs.notify({
                title:'Notification',
                text:'Update Reply Failed',
                color:'danger',
                position:'top-right'})
        }).catch((err) => {
          console.log(err)
        });
        this.popupReply = false;
      }
    },
    editReply(reviewData) {
      this.reply_content = reviewData.review_reply_comment;
      this.id_review = reviewData.review_id;
      this.popupReply = true;
      this.type = "update";
    },
    deleteReply() {
      const obj = {
        review_id : this.id_review,
        infoObj: this.infoObj
      }
      this.action_type = 'Delete';
      this.openLoadingInDiv();
      this.$store.dispatch("reviewList/DELETE_GOOGLE_REPLY_REVIEW", obj).then(() => {
        this.closeLoading();
          this.$vs.notify({
            title:'Notification',
            text:'Delete Reply Success',
            color:'success',
            position:'top-right'})
        }).catch(() => {
          this.closeLoading();
          this.$vs.notify({
            title:'Notification',
            text:'Delete Reply Failed',
            color:'danger',
            position:'top-right'})
      })
      this.popupDeleteActive = false;
    }
  }
};
</script>
